import React from 'react';

const SongsTable = ({ songs, count, missing }) => {
    return (
        <div className='row'>
            <div className="col-lg-12">
                {!count ? (
                    <p className="text-center text-danger">
                        None of the songs you entered could be found. <br />
                        Please click back button, and correct your list.
                    </p>
                ) : missing ? (
                    <p className="text-center text-danger">
                        Songs marked red could not be found. Please use back button to correct your list or click confirm to skip them.
                    </p>
                ) : (
                    <p className="text-center">
                        Please review if displayed songs are correct. If you want to change some of them, just click back button.
                    </p>
                )}
            </div>
            <div className="col-lg-12">
                <table className="display table table-bordered table-striped dataTable no-footer">
                    <thead>
                        <tr>
                            <th style={{ width: '1px' }}>SKU</th>
                            <th>Song title</th>
                            <th style={{ width: '1px' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {songs.map((song, index) => (
                            <tr key={index} className={!song.found ? 'missing' : 'xx'}>
                                <td style={{ width: '0' }}>
                                    {song.sku}
                                </td>
                                <td>
                                    {song.title}
                                </td>
                                <td>
                                    {song.found ? (
                                        <i className="fa fa-check text-success"></i>
                                    ) : (
                                        <i className="fa fa-times text-danger"></i>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SongsTable;